/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type PaymentsPreviewSubscriptionTotalsQueryVariables = Types.Exact<{
  input: Types.PreviewSubscriptionTotalsInput;
}>;


export type PaymentsPreviewSubscriptionTotalsQuery = { __typename?: 'Query', paymentsPreviewSubscriptionTotals: { __typename?: 'PreviewSubscriptionTotalsResponse', totals?: { __typename?: 'Totals', subtotal: number, tax: number, discount: number, total: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type PaymentsActivateTrialMutationVariables = Types.Exact<{
  input: Types.ActivateTrialInput;
  applyBonus: Types.Scalars['Boolean']['input'];
}>;


export type PaymentsActivateTrialMutation = { __typename?: 'Mutation', paymentsActivateTrial: { __typename?: 'ActivateTrialResponse', subscription?: { __typename?: 'SubscriptionPayload', id: string, status: Types.SubscriptionStatus, latestInvoice?: { __typename?: 'InvoicePayload', hostedUrl: string, paymentIntent?: { __typename?: 'PaymentIntentPayload', status: Types.PaymentIntentStatus } | null } | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type PaymentsExtendTrialMutationVariables = Types.Exact<{
  input: Types.PaymentsExtendTrialInput;
}>;


export type PaymentsExtendTrialMutation = { __typename?: 'Mutation', paymentsExtendTrial: { __typename?: 'PaymentsExtendTrialResponse', errors?: Array<{ __typename?: 'ErrorMessage', message: string }> | null, subscription?: { __typename?: 'SubscriptionPayload', id: string, status: Types.SubscriptionStatus, trialEndsAt?: any | null } | null } };

export type PaymentsAutoStartFreeTrialMutationVariables = Types.Exact<{
  stripeCustomerId: Types.Scalars['String']['input'];
  currencyCode: Types.AvailableCurrencyCode;
  subscriptionType: Types.SubscriptionTypeAutoStartTrial;
  promoCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PaymentsAutoStartFreeTrialMutation = { __typename?: 'Mutation', paymentsAutoStartTrial: { __typename?: 'paymentsAutoStartTrialResult', stripeSubscriptionId?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type PaymentsAutoStartSubscriptionMutationVariables = Types.Exact<{
  input: Types.PaymentsAutoStartSubscriptionInput;
}>;


export type PaymentsAutoStartSubscriptionMutation = { __typename?: 'Mutation', paymentsAutoStartSubscription: { __typename?: 'PaymentsAutoStartSubscriptionResponse', errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null, subscription?: { __typename?: 'SubscriptionPayload', id: string, status: Types.SubscriptionStatus, latestInvoice?: { __typename?: 'InvoicePayload', hostedUrl: string, paymentIntent?: { __typename?: 'PaymentIntentPayload', status: Types.PaymentIntentStatus } | null } | null } | null } };

export type PaymentsExtendSubscriptionMutationVariables = Types.Exact<{
  stripeSubscriptionId: Types.Scalars['String']['input'];
  stripeAccount?: Types.InputMaybe<Types.StripeAccount>;
}>;


export type PaymentsExtendSubscriptionMutation = { __typename?: 'Mutation', paymentsExtendSubscription: { __typename?: 'ExtendSubscriptionResult', paymentStatus: Types.PaymentStatus, nextPaymentDate?: any | null, payInvoiceUrl?: string | null, maxExtensionsReached?: boolean | null, userBanned?: boolean | null } };

export type CalculatePricesQueryVariables = Types.Exact<{
  currencyCode: Types.CurrencyCode;
  prices: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  match: Types.Scalars['Boolean']['input'];
}>;


export type CalculatePricesQuery = { __typename?: 'Query', calculatePrices: { __typename?: 'PriceCalculationsResponse', data?: { __typename?: 'CalculatePricesResponse', currency: Types.CurrencyCode, prices: Array<{ __typename?: 'TransformedPricesResponse', basePrice: number, currencyPrice: number }> } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type PaymentsStripeSubscriptionExtensionInfoQueryVariables = Types.Exact<{
  stripeCustomerId: Types.Scalars['String']['input'];
  isPolling?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  stripeAccount?: Types.InputMaybe<Types.StripeAccount>;
}>;


export type PaymentsStripeSubscriptionExtensionInfoQuery = { __typename?: 'Query', paymentsStripeSubscriptionExtensionInfo?: { __typename?: 'StripeSubscriptionExtensionInfo', stripeSubscriptionId?: string | null, inProgress: boolean, nextPaymentDate?: any | null, payInvoiceUrl?: string | null, paymentStatus?: Types.PaymentStatus | null } | null };

export type SubscriptionOptimisticallySetStateMutationVariables = Types.Exact<{
  input: Types.SubscriptionOptimisticallySetStateInput;
}>;


export type SubscriptionOptimisticallySetStateMutation = { __typename?: 'Mutation', subscriptionOptimisticallySetState?: { __typename?: 'SubscriptionOptimisticallySetStateResponse', accepted: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type PaymentsBuyCoinsMutationVariables = Types.Exact<{
  coinPack: Types.CoinPack;
  currencyCode: Types.AvailableCurrencyCode;
  custom?: Types.InputMaybe<Types.BuyCoinsCustomInput>;
}>;


export type PaymentsBuyCoinsMutation = { __typename?: 'Mutation', paymentsBuyCoins: { __typename?: 'paymentsBuyCoinsResult', paymentStatus: Types.PaymentStatus, payInvoiceUrl?: string | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type PaymentsCreateSetupIntentMutationVariables = Types.Exact<{
  input: Types.CreateSetupIntentInput;
}>;


export type PaymentsCreateSetupIntentMutation = { __typename?: 'Mutation', paymentsCreateSetupIntent: { __typename?: 'CreateSetupIntentResponse', setupIntent?: { __typename?: 'SetupIntent', id: string, clientSecret: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type PaymentsSubmitSubscriptionCheckoutMutationVariables = Types.Exact<{
  input: Types.SubmitSubscriptionCheckoutInput;
}>;


export type PaymentsSubmitSubscriptionCheckoutMutation = { __typename?: 'Mutation', paymentsSubmitSubscriptionCheckout: { __typename?: 'SubmitSubscriptionCheckoutResponse', subscription?: { __typename?: 'SubscriptionPayload', id: string, status: Types.SubscriptionStatus, latestInvoice?: { __typename?: 'InvoicePayload', hostedUrl: string, clientSecret?: string | null, paymentIntent?: { __typename?: 'PaymentIntentPayload', status: Types.PaymentIntentStatus } | null } | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type PaymentsAllowedPaymentMethodTypesQueryVariables = Types.Exact<{
  input: Types.AllowedPaymentMethodTypesInput;
}>;


export type PaymentsAllowedPaymentMethodTypesQuery = { __typename?: 'Query', paymentsAllowedPaymentMethodTypes: { __typename?: 'AllowedPaymentMethodTypesResponse', types?: Array<Types.AvailablePaymentMethod> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type PaymentsCustomerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PaymentsCustomerQuery = { __typename?: 'Query', paymentsCustomer: { __typename?: 'PaymentsCustomerResponse', customer: { __typename?: 'Customer', name: string, email: string, taxId: string, country: string }, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };


export const PaymentsActivateTrialDocument = `
mutation paymentsActivateTrial($input: ActivateTrialInput!, $applyBonus: Boolean!) {
  paymentsActivateTrial(input: $input, applyBonus: $applyBonus) {
    subscription {
      id
      status
      latestInvoice {
        hostedUrl
        paymentIntent {
          status
        }
      }
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsActivateTrialMutationKey = 'paymentsActivateTrial'

export function paymentsActivateTrialMutationFetcher(variables: PaymentsActivateTrialMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsActivateTrialMutation, PaymentsActivateTrialMutationVariables>(PaymentsActivateTrialDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsActivateTrialMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsActivateTrialMutation, E, PaymentsActivateTrialMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsActivateTrialMutation, E, PaymentsActivateTrialMutationVariables, C>({
        ...options,
        mutationKey: [paymentsActivateTrialMutationKey],
        mutationFn: (variables: PaymentsActivateTrialMutationVariables) => paymentsActivateTrialMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsExtendTrialDocument = `
mutation paymentsExtendTrial($input: PaymentsExtendTrialInput!) {
  paymentsExtendTrial(input: $input) {
    errors {
      message
    }
    subscription {
      id
      status
      trialEndsAt
    }
  }
}

`

export const paymentsExtendTrialMutationKey = 'paymentsExtendTrial'

export function paymentsExtendTrialMutationFetcher(variables: PaymentsExtendTrialMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsExtendTrialMutation, PaymentsExtendTrialMutationVariables>(PaymentsExtendTrialDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsExtendTrialMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsExtendTrialMutation, E, PaymentsExtendTrialMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsExtendTrialMutation, E, PaymentsExtendTrialMutationVariables, C>({
        ...options,
        mutationKey: [paymentsExtendTrialMutationKey],
        mutationFn: (variables: PaymentsExtendTrialMutationVariables) => paymentsExtendTrialMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsAutoStartFreeTrialDocument = `
mutation paymentsAutoStartFreeTrial($stripeCustomerId: String!, $currencyCode: AvailableCurrencyCode!, $subscriptionType: SubscriptionTypeAutoStartTrial!, $promoCode: String) {
  paymentsAutoStartTrial(
    stripeCustomerId: $stripeCustomerId
    currencyCode: $currencyCode
    subscriptionType: $subscriptionType
    promoCode: $promoCode
  ) {
    stripeSubscriptionId
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsAutoStartFreeTrialMutationKey = 'paymentsAutoStartFreeTrial'

export function paymentsAutoStartFreeTrialMutationFetcher(variables: PaymentsAutoStartFreeTrialMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsAutoStartFreeTrialMutation, PaymentsAutoStartFreeTrialMutationVariables>(PaymentsAutoStartFreeTrialDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsAutoStartFreeTrialMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsAutoStartFreeTrialMutation, E, PaymentsAutoStartFreeTrialMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsAutoStartFreeTrialMutation, E, PaymentsAutoStartFreeTrialMutationVariables, C>({
        ...options,
        mutationKey: [paymentsAutoStartFreeTrialMutationKey],
        mutationFn: (variables: PaymentsAutoStartFreeTrialMutationVariables) => paymentsAutoStartFreeTrialMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsAutoStartSubscriptionDocument = `
mutation paymentsAutoStartSubscription($input: PaymentsAutoStartSubscriptionInput!) {
  paymentsAutoStartSubscription(input: $input) {
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
    subscription {
      id
      status
      latestInvoice {
        hostedUrl
        paymentIntent {
          status
        }
      }
    }
  }
}

`

export const paymentsAutoStartSubscriptionMutationKey = 'paymentsAutoStartSubscription'

export function paymentsAutoStartSubscriptionMutationFetcher(variables: PaymentsAutoStartSubscriptionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsAutoStartSubscriptionMutation, PaymentsAutoStartSubscriptionMutationVariables>(PaymentsAutoStartSubscriptionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsAutoStartSubscriptionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsAutoStartSubscriptionMutation, E, PaymentsAutoStartSubscriptionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsAutoStartSubscriptionMutation, E, PaymentsAutoStartSubscriptionMutationVariables, C>({
        ...options,
        mutationKey: [paymentsAutoStartSubscriptionMutationKey],
        mutationFn: (variables: PaymentsAutoStartSubscriptionMutationVariables) => paymentsAutoStartSubscriptionMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsExtendSubscriptionDocument = `
mutation paymentsExtendSubscription($stripeSubscriptionId: String!, $stripeAccount: StripeAccount) {
  paymentsExtendSubscription(
    stripeSubscriptionId: $stripeSubscriptionId
    stripeAccount: $stripeAccount
  ) {
    paymentStatus
    nextPaymentDate
    payInvoiceUrl
    maxExtensionsReached
    userBanned
  }
}

`

export const paymentsExtendSubscriptionMutationKey = 'paymentsExtendSubscription'

export function paymentsExtendSubscriptionMutationFetcher(variables: PaymentsExtendSubscriptionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsExtendSubscriptionMutation, PaymentsExtendSubscriptionMutationVariables>(PaymentsExtendSubscriptionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsExtendSubscriptionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsExtendSubscriptionMutation, E, PaymentsExtendSubscriptionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsExtendSubscriptionMutation, E, PaymentsExtendSubscriptionMutationVariables, C>({
        ...options,
        mutationKey: [paymentsExtendSubscriptionMutationKey],
        mutationFn: (variables: PaymentsExtendSubscriptionMutationVariables) => paymentsExtendSubscriptionMutationFetcher(variables, fetchOptions),
    })
}

export const SubscriptionOptimisticallySetStateDocument = `
mutation subscriptionOptimisticallySetState($input: SubscriptionOptimisticallySetStateInput!) {
  subscriptionOptimisticallySetState(input: $input) {
    accepted
    errors {
      code
      message
    }
  }
}

`

export const subscriptionOptimisticallySetStateMutationKey = 'subscriptionOptimisticallySetState'

export function subscriptionOptimisticallySetStateMutationFetcher(variables: SubscriptionOptimisticallySetStateMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SubscriptionOptimisticallySetStateMutation, SubscriptionOptimisticallySetStateMutationVariables>(SubscriptionOptimisticallySetStateDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSubscriptionOptimisticallySetStateMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SubscriptionOptimisticallySetStateMutation, E, SubscriptionOptimisticallySetStateMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SubscriptionOptimisticallySetStateMutation, E, SubscriptionOptimisticallySetStateMutationVariables, C>({
        ...options,
        mutationKey: [subscriptionOptimisticallySetStateMutationKey],
        mutationFn: (variables: SubscriptionOptimisticallySetStateMutationVariables) => subscriptionOptimisticallySetStateMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsBuyCoinsDocument = `
mutation paymentsBuyCoins($coinPack: coinPack!, $currencyCode: AvailableCurrencyCode!, $custom: BuyCoinsCustomInput) {
  paymentsBuyCoins(
    coinPack: $coinPack
    currencyCode: $currencyCode
    custom: $custom
  ) {
    paymentStatus
    payInvoiceUrl
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsBuyCoinsMutationKey = 'paymentsBuyCoins'

export function paymentsBuyCoinsMutationFetcher(variables: PaymentsBuyCoinsMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsBuyCoinsMutation, PaymentsBuyCoinsMutationVariables>(PaymentsBuyCoinsDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsBuyCoinsMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsBuyCoinsMutation, E, PaymentsBuyCoinsMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsBuyCoinsMutation, E, PaymentsBuyCoinsMutationVariables, C>({
        ...options,
        mutationKey: [paymentsBuyCoinsMutationKey],
        mutationFn: (variables: PaymentsBuyCoinsMutationVariables) => paymentsBuyCoinsMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsCreateSetupIntentDocument = `
mutation paymentsCreateSetupIntent($input: CreateSetupIntentInput!) {
  paymentsCreateSetupIntent(input: $input) {
    setupIntent {
      id
      clientSecret
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsCreateSetupIntentMutationKey = 'paymentsCreateSetupIntent'

export function paymentsCreateSetupIntentMutationFetcher(variables: PaymentsCreateSetupIntentMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsCreateSetupIntentMutation, PaymentsCreateSetupIntentMutationVariables>(PaymentsCreateSetupIntentDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsCreateSetupIntentMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsCreateSetupIntentMutation, E, PaymentsCreateSetupIntentMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsCreateSetupIntentMutation, E, PaymentsCreateSetupIntentMutationVariables, C>({
        ...options,
        mutationKey: [paymentsCreateSetupIntentMutationKey],
        mutationFn: (variables: PaymentsCreateSetupIntentMutationVariables) => paymentsCreateSetupIntentMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsSubmitSubscriptionCheckoutDocument = `
mutation paymentsSubmitSubscriptionCheckout($input: SubmitSubscriptionCheckoutInput!) {
  paymentsSubmitSubscriptionCheckout(input: $input) {
    subscription {
      id
      status
      latestInvoice {
        hostedUrl
        clientSecret
        paymentIntent {
          status
        }
      }
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsSubmitSubscriptionCheckoutMutationKey = 'paymentsSubmitSubscriptionCheckout'

export function paymentsSubmitSubscriptionCheckoutMutationFetcher(variables: PaymentsSubmitSubscriptionCheckoutMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsSubmitSubscriptionCheckoutMutation, PaymentsSubmitSubscriptionCheckoutMutationVariables>(PaymentsSubmitSubscriptionCheckoutDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function usePaymentsSubmitSubscriptionCheckoutMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<PaymentsSubmitSubscriptionCheckoutMutation, E, PaymentsSubmitSubscriptionCheckoutMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<PaymentsSubmitSubscriptionCheckoutMutation, E, PaymentsSubmitSubscriptionCheckoutMutationVariables, C>({
        ...options,
        mutationKey: [paymentsSubmitSubscriptionCheckoutMutationKey],
        mutationFn: (variables: PaymentsSubmitSubscriptionCheckoutMutationVariables) => paymentsSubmitSubscriptionCheckoutMutationFetcher(variables, fetchOptions),
    })
}

export const PaymentsPreviewSubscriptionTotalsDocument = `
query paymentsPreviewSubscriptionTotals($input: PreviewSubscriptionTotalsInput!) {
  paymentsPreviewSubscriptionTotals(input: $input) {
    totals {
      subtotal
      tax
      discount
      total
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsPreviewSubscriptionTotalsQueryRootKey = 'paymentsPreviewSubscriptionTotals'

export function paymentsPreviewSubscriptionTotalsQueryFetcher(variables: PaymentsPreviewSubscriptionTotalsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsPreviewSubscriptionTotalsQuery, PaymentsPreviewSubscriptionTotalsQueryVariables>(PaymentsPreviewSubscriptionTotalsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function paymentsPreviewSubscriptionTotalsQueryKey(variables: PaymentsPreviewSubscriptionTotalsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [paymentsPreviewSubscriptionTotalsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function paymentsPreviewSubscriptionTotalsQueryOptions(
    variables: PaymentsPreviewSubscriptionTotalsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PaymentsPreviewSubscriptionTotalsQuery, unknown, PaymentsPreviewSubscriptionTotalsQuery, (PaymentsPreviewSubscriptionTotalsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: paymentsPreviewSubscriptionTotalsQueryKey(variables, fetchOptions),
        queryFn: paymentsPreviewSubscriptionTotalsQueryFetcher(variables, fetchOptions),
    }
}

export function usePaymentsPreviewSubscriptionTotalsQuery<D = PaymentsPreviewSubscriptionTotalsQuery, E = unknown>(
    variables: PaymentsPreviewSubscriptionTotalsQueryVariables,
    options?: Omit<UseQueryOptions<PaymentsPreviewSubscriptionTotalsQuery, E, D, (PaymentsPreviewSubscriptionTotalsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PaymentsPreviewSubscriptionTotalsQuery, E, D, (PaymentsPreviewSubscriptionTotalsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...paymentsPreviewSubscriptionTotalsQueryOptions(variables, fetchOptions),
    })
}

export const CalculatePricesDocument = `
query calculatePrices($currencyCode: CurrencyCode!, $prices: [Int!]!, $match: Boolean!) {
  calculatePrices(
    input: {match: $match, prices: $prices, currency: $currencyCode}
  ) {
    data {
      currency
      prices {
        basePrice
        currencyPrice
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const calculatePricesQueryRootKey = 'calculatePrices'

export function calculatePricesQueryFetcher(variables: CalculatePricesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<CalculatePricesQuery, CalculatePricesQueryVariables>(CalculatePricesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function calculatePricesQueryKey(variables: CalculatePricesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [calculatePricesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function calculatePricesQueryOptions(
    variables: CalculatePricesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<CalculatePricesQuery, unknown, CalculatePricesQuery, (CalculatePricesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: calculatePricesQueryKey(variables, fetchOptions),
        queryFn: calculatePricesQueryFetcher(variables, fetchOptions),
    }
}

export function useCalculatePricesQuery<D = CalculatePricesQuery, E = unknown>(
    variables: CalculatePricesQueryVariables,
    options?: Omit<UseQueryOptions<CalculatePricesQuery, E, D, (CalculatePricesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<CalculatePricesQuery, E, D, (CalculatePricesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...calculatePricesQueryOptions(variables, fetchOptions),
    })
}

export const PaymentsStripeSubscriptionExtensionInfoDocument = `
query paymentsStripeSubscriptionExtensionInfo($stripeCustomerId: String!, $isPolling: Boolean, $stripeAccount: StripeAccount) {
  paymentsStripeSubscriptionExtensionInfo(
    stripeCustomerId: $stripeCustomerId
    isPolling: $isPolling
    stripeAccount: $stripeAccount
  ) {
    stripeSubscriptionId
    inProgress
    nextPaymentDate
    payInvoiceUrl
    paymentStatus
  }
}

`

export const paymentsStripeSubscriptionExtensionInfoQueryRootKey = 'paymentsStripeSubscriptionExtensionInfo'

export function paymentsStripeSubscriptionExtensionInfoQueryFetcher(variables: PaymentsStripeSubscriptionExtensionInfoQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsStripeSubscriptionExtensionInfoQuery, PaymentsStripeSubscriptionExtensionInfoQueryVariables>(PaymentsStripeSubscriptionExtensionInfoDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function paymentsStripeSubscriptionExtensionInfoQueryKey(variables: PaymentsStripeSubscriptionExtensionInfoQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [paymentsStripeSubscriptionExtensionInfoQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function paymentsStripeSubscriptionExtensionInfoQueryOptions(
    variables: PaymentsStripeSubscriptionExtensionInfoQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PaymentsStripeSubscriptionExtensionInfoQuery, unknown, PaymentsStripeSubscriptionExtensionInfoQuery, (PaymentsStripeSubscriptionExtensionInfoQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: paymentsStripeSubscriptionExtensionInfoQueryKey(variables, fetchOptions),
        queryFn: paymentsStripeSubscriptionExtensionInfoQueryFetcher(variables, fetchOptions),
    }
}

export function usePaymentsStripeSubscriptionExtensionInfoQuery<D = PaymentsStripeSubscriptionExtensionInfoQuery, E = unknown>(
    variables: PaymentsStripeSubscriptionExtensionInfoQueryVariables,
    options?: Omit<UseQueryOptions<PaymentsStripeSubscriptionExtensionInfoQuery, E, D, (PaymentsStripeSubscriptionExtensionInfoQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PaymentsStripeSubscriptionExtensionInfoQuery, E, D, (PaymentsStripeSubscriptionExtensionInfoQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...paymentsStripeSubscriptionExtensionInfoQueryOptions(variables, fetchOptions),
    })
}

export const PaymentsAllowedPaymentMethodTypesDocument = `
query paymentsAllowedPaymentMethodTypes($input: AllowedPaymentMethodTypesInput!) {
  paymentsAllowedPaymentMethodTypes(input: $input) {
    types
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsAllowedPaymentMethodTypesQueryRootKey = 'paymentsAllowedPaymentMethodTypes'

export function paymentsAllowedPaymentMethodTypesQueryFetcher(variables: PaymentsAllowedPaymentMethodTypesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsAllowedPaymentMethodTypesQuery, PaymentsAllowedPaymentMethodTypesQueryVariables>(PaymentsAllowedPaymentMethodTypesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function paymentsAllowedPaymentMethodTypesQueryKey(variables: PaymentsAllowedPaymentMethodTypesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [paymentsAllowedPaymentMethodTypesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function paymentsAllowedPaymentMethodTypesQueryOptions(
    variables: PaymentsAllowedPaymentMethodTypesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PaymentsAllowedPaymentMethodTypesQuery, unknown, PaymentsAllowedPaymentMethodTypesQuery, (PaymentsAllowedPaymentMethodTypesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: paymentsAllowedPaymentMethodTypesQueryKey(variables, fetchOptions),
        queryFn: paymentsAllowedPaymentMethodTypesQueryFetcher(variables, fetchOptions),
    }
}

export function usePaymentsAllowedPaymentMethodTypesQuery<D = PaymentsAllowedPaymentMethodTypesQuery, E = unknown>(
    variables: PaymentsAllowedPaymentMethodTypesQueryVariables,
    options?: Omit<UseQueryOptions<PaymentsAllowedPaymentMethodTypesQuery, E, D, (PaymentsAllowedPaymentMethodTypesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PaymentsAllowedPaymentMethodTypesQuery, E, D, (PaymentsAllowedPaymentMethodTypesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...paymentsAllowedPaymentMethodTypesQueryOptions(variables, fetchOptions),
    })
}

export const PaymentsCustomerDocument = `
query paymentsCustomer {
  paymentsCustomer {
    customer {
      name
      email
      taxId
      country
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const paymentsCustomerQueryRootKey = 'paymentsCustomer'

export function paymentsCustomerQueryFetcher(variables?: PaymentsCustomerQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PaymentsCustomerQuery, PaymentsCustomerQueryVariables>(PaymentsCustomerDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function paymentsCustomerQueryKey(variables?: PaymentsCustomerQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [paymentsCustomerQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function paymentsCustomerQueryOptions(
    variables?: PaymentsCustomerQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PaymentsCustomerQuery, unknown, PaymentsCustomerQuery, (PaymentsCustomerQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: paymentsCustomerQueryKey(variables, fetchOptions),
        queryFn: paymentsCustomerQueryFetcher(variables, fetchOptions),
    }
}

export function usePaymentsCustomerQuery<D = PaymentsCustomerQuery, E = unknown>(
    variables?: PaymentsCustomerQueryVariables,
    options?: Omit<UseQueryOptions<PaymentsCustomerQuery, E, D, (PaymentsCustomerQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PaymentsCustomerQuery, E, D, (PaymentsCustomerQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...paymentsCustomerQueryOptions(variables, fetchOptions),
    })
}